// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\r\n.src-pages-home-recomended-style__items--3pzU-{\r\n      display: flex;\r\n      flex-direction: row;\r\n      flex-wrap: wrap;\r\n      justify-content: space-between;\r\n}\r\n", "",{"version":3,"sources":["webpack://src/pages/home/recomended/style.css"],"names":[],"mappings":";AACA;MACM,aAAa;MACb,mBAAmB;MACnB,eAAe;MACf,8BAA8B;AACpC","sourcesContent":["\r\n.items{\r\n      display: flex;\r\n      flex-direction: row;\r\n      flex-wrap: wrap;\r\n      justify-content: space-between;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"items": "src-pages-home-recomended-style__items--3pzU-"
};
export default ___CSS_LOADER_EXPORT___;
